var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-title"},[_c('div',{staticClass:"base-title-inner"},[_c('div',{staticClass:"bti-english"}),_c('p',[_vm._v(_vm._s(_vm.titleText))]),_c('div',{staticClass:"right_text"},[_vm._v(_vm._s(_vm.subText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }